export default __webpack_public_path__ + "static/media/panel-xl.50166c2c.svg";